import script from "./ArrivalsAndDeliveries.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrivalsAndDeliveries.vue?vue&type=script&setup=true&lang=js"

import "./ArrivalsAndDeliveries.vue?vue&type=style&index=0&id=3245e8f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3245e8f7"]])

export default __exports__